<div class="container-fluid d-flex p-0">

  <!-- Header Block -->
  <div class="container-fluid">
    <div class="table-responsive">
      <table class="table table-bordered">
        <tbody>
          <tr *ngFor="let Obj of refData ; let index=index">
            <td>{{Obj.Phase}}</td>
            <td>
              <div class="d-flex" *ngFor="let res of Obj.Values">
                <div class="value-aligncontent">
                  {{res.Value}}
                </div>
              </div>
            </td>
            <td> </td>
            <td>
              <div class="value-aligncontent text-center">
                <select style="width:90%;" [(ngModel)]="Obj.selectedBatch" (change)="dropDrownDataChange()">
                  <option *ngFor="let res of Obj?.batch_size">{{res}}</option>
                </select>
                <div class="total" style="width:90%">{{Obj.sum_of_strengths}}</div>
                <select style="width:90%;" [(ngModel)]="Obj.selectedNuberBatch" (change)="dropDrownDataChange()">
                  <option *ngFor="let res of Obj?.num_of_batches">{{res}}</option>
                </select>
                <div class="total" style="width:90%">{{Obj.total}}</div>
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="font-weight-bold">Grand Total</td>
            <td class="font-weight-bold">Sum(All Total API(KG))</td>
            <td class="font-weight-bold text-center">{{total}}</td>
          </tr>
          <tr>
          </tr>
        </tbody>
      </table>
    </div>
    <button class="btn btn-primary float-right" style="margin-top:1rem" (click)="onClickNext()"
      [disabled]="!enableNextButton">{{name}}</button>
    <button class="btn btn-primary float-right mr-4" style="margin-top:1rem;" (click)="onClickSubmit()">Submit</button>
  </div>
</div>
